import { render, staticRenderFns } from "./CreditBook.vue?vue&type=template&id=6dacde1e&scoped=true"
import script from "./CreditBook.vue?vue&type=script&lang=js"
export * from "./CreditBook.vue?vue&type=script&lang=js"
import style0 from "./CreditBook.vue?vue&type=style&index=0&id=6dacde1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dacde1e",
  null
  
)

export default component.exports